export default {"src":"/_next/static/media/IconLargeGearProtection.15539a33.svg","height":28,"width":44,"blurWidth":0,"blurHeight":0};